import React, { ReactElement, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TextColorTypes } from '../../Theme/Fonts/FontTypes'
import Caption from '../../Theme/Fonts/Caption'
import { TintColor } from '../../BaseComponents/Image/ImageInterfaces'
import TagImage, { TagImageTypes } from '../../BaseComponents/Image/Tag'

interface ChannelProps {
    name: string
    imageUrl?: string
    alt?: string
    captionColor?: TextColorTypes
    tintColor?: TintColor
    type?: TagImageTypes
    hideImage?: boolean
}

const Channel: FunctionComponent<ChannelProps> = ({
    name,
    imageUrl,
    alt,
    captionColor = 'keshi-3',
    tintColor,
    hideImage,
    type,
}): ReactElement => (
    <Grid noExpand horizontal centerVertical flexShrink={1} minWidth={0}>
        {!hideImage ? (
            <Grid noExpand minWidth={24}>
                <TagImage imageUrl={imageUrl} alt={alt} tintColor={tintColor} type={type} />
            </Grid>
        ) : null}
        <Grid noExpand minWidth={0}>
            <Caption numberOfLines={1} color={captionColor}>
                {name}
            </Caption>
        </Grid>
    </Grid>
)

export default Channel
